'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$47() {
  this.bjV = null;
  this.bjW = false;
}
export { $c_Lpresto_PrestoRouter$$anon$47 as $c_Lpresto_PrestoRouter$$anon$47 };
$p = $c_Lpresto_PrestoRouter$$anon$47.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$47;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$47() {
}
export { $h_Lpresto_PrestoRouter$$anon$47 as $h_Lpresto_PrestoRouter$$anon$47 };
$h_Lpresto_PrestoRouter$$anon$47.prototype = $p;
$p.c1 = (function() {
  if ((!this.bjW)) {
    this.bjV = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bjW = true;
  }
  return this.bjV;
});
$p.P = (function() {
  return this.c1();
});
var $d_Lpresto_PrestoRouter$$anon$47 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$47, "presto.PrestoRouter$$anon$47", ({
  Om: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$47 as $d_Lpresto_PrestoRouter$$anon$47 };
//# sourceMappingURL=presto.-Presto-Router$$anon$47.js.map
